import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Icon from '@material-ui/core/Icon';
import React, {useEffect, useState} from 'react';
import {withStyles} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import FormField from '../Form/FormField';
import FormCheck from '../Form/FormCheck';
import i18n from '../../i18n';
import FormColor from '../Form/FormColor';
import swal from "sweetalert";
import FormSelect from "../Form/FormSelect";

const ProjectStatusEdit = (props) => {
    const [values, setValues] = useState(props.values);
    const [edit, setEdit] = useState(props.edit || false);
    const [prev, setPrev] = useState(props.values.event);
    const [options,setOptions] = useState([]);


    const setOptionsList = (event) => {
        let selection;
        if(event && !props.eventsList.includes(event)) {
            selection = [event,...props.eventsList]
        } else {
            selection = props.eventsList;
        }
        setOptions( selection.map(event => {
                return {
                    label: i18n.get('deficiency.events.' + event),
                    value: event,
                }
            }) )
    }

    useEffect(() => {
        props.setEventsList(props.eventsList);
        setOptionsList(props.values.event);
    },[props]);

    return (
        <TableRow>
            <TableCell>
                {edit ? (
                    <FormField
                        type={'text'}
                        name={'name'}
                        label={i18n.get('project.status_form.name')}
                        value={values.name}
                        onChange={(e) => {
                            setValues({...values, name: e.target.value});
                        }}
                    />
                ) : values.name}
            </TableCell>
            <TableCell align={'center'}>
                {edit ? (
                    <React.Fragment>
                        {values.color}
                        <FormColor
                            color={values.color || '#ffffff'}
                            onChange={(color) => {
                                setValues({...values, color: color});
                            }}
                        />
                    </React.Fragment>
                ) : (
                    <Icon style={{color: values.color}}>color_lens</Icon>
                )}
            </TableCell>
            <TableCell align={'center'}>
                {
                    edit ? (
                        <FormCheck
                            name={'closed'}
                            label={''}
                            value={values.closed}
                            onChange={(e, chk) => {
                                setValues({...values, closed: chk});
                            }}
                        />
                    ) : values.closed && (
                        <Icon color="primary">check_box</Icon>
                    )
                }
            </TableCell>
            <TableCell align={'center'}>
                {edit ? (
                    <FormField
                        type={'number'}
                        name={'prio'}
                        max={1000}
                        min={-1000}
                        label={i18n.get('project.status_form.prio')}
                        value={values.prio}
                        onChange={(e) => {
                            let prio = parseInt(e.target.value);
                            if (prio === null) {
                                prio = 0;
                            }
                            setValues({...values, prio});
                        }}
                    />
                ) : values.prio}
            </TableCell>
            <TableCell align={'center'}>
                {edit ? (
                    <FormCheck
                        name={'default'}
                        value={values.default}
                        onChange={(e, chk) => {
                            setValues({...values, default: chk});
                        }}/>
                ): values.default && (
                    <Icon color="primary">check_box</Icon>
                )}
            </TableCell>
            <TableCell>
                {edit ? (
                    <FormSelect
                        type="text"
                        name="event"
                        label={i18n.get('project.status_form.event')}
                        onChange={(e) => {
                            if(e && e.value){
                                setValues({...values, event: e.value });
                                setPrev(e.value);
                            } else {
                                props.changeEventsList(prev,'restore');
                                setValues({...values, event: null });
                            }
                        }}
                        options={options}
                        placeholder={'Select Event'}
                        value={values.event || ''}
                        isClearable={true}
                    />
                ): values.event && i18n.get('deficiency.events.' + values.event) }
            </TableCell>
            <TableCell align={'center'}>
                {edit ? (
                    <React.Fragment>
                        <IconButton
                            onClick={() => {
                                if (props.onChange) {
                                    if(values.name === null || values.name.length === 0) {
                                        return swal({
                                            text: 'please set a status name',
                                            icon: 'warning',
                                            timer: 4000,
                                        })
                                    } else {
                                        setEdit(false);
                                        props.onChange(values);
                                    }
                                }
                            }}
                        >
                            <Icon>save</Icon>
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                setEdit(false);
                                setValues(props.values);
                                if(props.setAdds) {
                                    props.setAdds({data: []});
                                }
                            }}
                        >
                            <Icon>cancel</Icon>
                        </IconButton>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <IconButton
                            onClick={() => {
                                setEdit(true);
                            }}
                        >
                            <Icon>edit</Icon>
                        </IconButton>
                        {values.projects && (
                            <IconButton
                                onClick={() => {`there are ${values.projects.length} dependencies`
                                    let length = values.projects.length;

                                    if(length) {
                                        return swal({
                                            title: i18n.get('project.status_form.delete_is_impossible'),
                                            text: length > 1
                                                ? i18n.get('project.status_form.dependencies',
                                                {quantity:String(length)})
                                                : i18n.get('project.status_form.dependency'),
                                            icon: 'warning',
                                            dangerMode: true,
                                        })
                                    } else {
                                        return swal({
                                            title: i18n.get('project.status_form.want_to_delete',
                                                { status:values.name }),
                                            icon: 'warning',
                                            dangerMode: true,
                                            buttons: {
                                                cancel: i18n.get('project.cancel'),
                                                confirm: i18n.get('project.delete'),
                                            },
                                        }).then(confirm => {
                                            if(confirm) {
                                                props.deleteStatus(values.id);
                                            }
                                        });
                                    }
                                }}
                            >
                                <Icon>delete</Icon>
                            </IconButton>
                        )}
                    </React.Fragment>
                )}
            </TableCell>
        </TableRow>
    );
};

const styles = {};

export default withStyles(styles)(ProjectStatusEdit);
